/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * OAuth application info without the secret.
 * @export
 * @interface OAuthApplication
 */
export interface OAuthApplication {
    /**
     * 
     * @type {string}
     * @memberof OAuthApplication
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthApplication
     */
    clientId: string;
    /**
     * 
     * @type {Date}
     * @memberof OAuthApplication
     */
    created: Date;
}

/**
 * Check if a given object implements the OAuthApplication interface.
 */
export function instanceOfOAuthApplication(value: object): value is OAuthApplication {
    if (!('name' in value) || value['name'] === undefined) return false;
    if ((!('clientId' in (value as Record<string, any>)) && !('client_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['clientId'] === undefined && (value as Record<string, any>)['client_id'] === undefined)) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function OAuthApplicationFromJSON(json: any): OAuthApplication {
    return OAuthApplicationFromJSONTyped(json, false);
}

export function OAuthApplicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthApplication {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'clientId': json['client_id'],
        'created': (new Date(json['created'])),
    };
}

export function OAuthApplicationToJSON(json: any): OAuthApplication {
    return OAuthApplicationToJSONTyped(json, false);
}

export function OAuthApplicationToJSONTyped(value?: OAuthApplication | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'client_id': value['clientId'],
        'created': value['created'].toISOString(),
    };
}

